import React from 'react';
import { type LucideProps } from 'lucide-react';

const CartIcon = (props: LucideProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12889_1724)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.3624 4.03016C4.01812 4.49187 4.34763 5.1486 4.92356 5.1486H19.9678C20.5437 5.1486 20.8732 4.49186 20.5289 4.03016L19.2251 2.28156C19.0929 2.10438 18.8849 2 18.6639 2H6.22742C6.0064 2 5.79837 2.10438 5.66625 2.28156L4.3624 4.03016ZM8.78935 9.33923C8.78935 9.04533 8.55109 8.80708 8.2572 8.80708C7.9633 8.80708 7.72505 9.04533 7.72505 9.33923C7.72505 11.9573 9.83569 14.0842 12.4457 14.0842C15.0557 14.0842 17.1657 11.9572 17.1657 9.33923C17.1657 9.04533 16.9275 8.80708 16.6336 8.80708C16.3397 8.80708 16.1014 9.04533 16.1014 9.33923C16.1014 11.3754 14.462 13.0199 12.4457 13.0199C10.4292 13.0199 8.78935 11.3753 8.78935 9.33923ZM3.7 6.21289C3.3134 6.21289 3 6.5263 3 6.91289V21.4235C3 21.5764 3.06074 21.723 3.16885 21.8312C3.27696 21.9393 3.4236 22 3.5765 22H21.3148C21.4677 22 21.6144 21.9393 21.7225 21.8312C21.8306 21.723 21.8913 21.5764 21.8913 21.4235V6.91289C21.8913 6.5263 21.5779 6.21289 21.1913 6.21289H3.7Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_12889_1724">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CartIcon;
